var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CardTypes } from "@react-components/ui/Cards/card-types";
import { FavoriteCard } from "@react-components/ui/Cards/FavoriteCard/FavoriteCard";
import { ContentCard } from "@react-components/ui/Cards/ContentCard/ContentCard";
import { ContentCard as SearchContentCard } from "@react-components/ui/Cards/SearchCards/ContentCard/ContentCard";
import { ContactCard } from "@react-components/ui/Cards/ContactCard/ContactCard";
var CardRenderer = function (_a) {
    var componentType = _a.componentType, props = _a.props, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight, useRatio = _a.useRatio;
    var newProps = Object.assign({}, props, {
        imageWidth: imageWidth,
    }, {
        imageHeight: imageHeight,
    }, useRatio);
    switch (componentType) {
        case CardTypes.FavoriteCard:
            return _jsx(FavoriteCard, __assign({}, newProps), void 0);
        case CardTypes.ContentCard:
            return _jsx(ContentCard, __assign({}, newProps), void 0);
        case CardTypes.SearchContentCard:
            return (_jsx(SearchContentCard, __assign({}, newProps), void 0));
        case CardTypes.ContactCard:
            return (_jsx(ContactCard, __assign({}, newProps, { withDialog: true }), void 0));
        default:
            return null;
    }
};
export { CardRenderer };
